import axios from 'axios'
import _ from 'lodash'
import { sanitizeSavingsPlan } from './utilsSavingPlanBFF'
import { SAVINGS_PLAN_ENDPOINT } from 'cfgCommon/endpoints'

export async function updateSavingsPlan(savingsPlan, car_lot_id, checkFeeIncluded, originalSavingPlan, savingPlanId) {
    const { bonifications, subscriptionDiscount, additionalDiscount } = savingsPlan
    try {
        const savingsPlanBody = sanitizeSavingsPlan(savingsPlan, car_lot_id, checkFeeIncluded)
        
        delete savingsPlanBody.SavingsPlan.datamaster_id

        // Se eliminan las propiedades que no cambiaron para no enviarlo al backend
        if (_.isEqual(bonifications, originalSavingPlan.bonifications)) delete savingsPlanBody.SavingsPlan.benefits
        if (
            _.isEqual(subscriptionDiscount, originalSavingPlan.subscriptionDiscount) &&
            _.isEqual(additionalDiscount, originalSavingPlan.additionalDiscount)
        )
            delete savingsPlanBody.SavingsPlan.bonifications

        const response = await axios.put(`${SAVINGS_PLAN_ENDPOINT}/${savingPlanId}`, savingsPlanBody)
        return response
    } catch (error) {
        // Si vuelve un error con mensaje mensaje del backend, se usa ese mensaje
        if (error?.response?.data?.message) error.message = error.response.data.message

        throw error
    }
}
